import { useNavigate, useLocation } from 'react-router-dom';
import { useAppStore, sel } from '../../store/useAppStore.js';
import { cn } from '../../lib/utils.js';

const ALL_NAV_ITEMS = [
  { path: '/',         label: 'Home',    icon: '🏠' },
  { path: '/scan',     label: 'Scan',    icon: '📷' },
  { path: '/session',  label: 'Session', icon: '👥' },
  { path: '/history',  label: 'History', icon: '📋' },
  { path: '/settings', label: 'Settings',icon: '⚙️' },
];

export const BottomNav = () => {
  const navigate       = useNavigate();
  const { pathname }   = useLocation();
  const currentSession = useAppStore(sel.session);
  const isGuest        = useAppStore(sel.isGuest);
  const clearSession   = useAppStore((s) => s.clearSession);
  const HIDE_NAV_PATHS = ['/auth'];
  if (HIDE_NAV_PATHS.includes(pathname)) return null;

  // Guest mode: QR participants only see the Session screen + a Leave button.
  if (isGuest) {
    return (
      <nav
        className="fixed bottom-0 left-0 right-0 z-40 max-w-[430px] mx-auto"
        style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
      >
        <div className="bg-surface/95 border-t border-white/8 backdrop-blur-xl flex">
          <button
            onClick={() => navigate('/session')}
            className="flex-1 flex flex-col items-center gap-1 py-2 px-1 touch-target"
          >
            <span style={{ fontSize: 18 }}>👥</span>
            <span className={cn('text-[9px] font-bold tracking-wide',
              pathname.startsWith('/session') ? 'text-brand-purple-light' : 'text-white/40')}>Session</span>
          </button>
          <button
            onClick={() => { clearSession(); navigate('/join'); }}
            className="flex-1 flex flex-col items-center gap-1 py-2 px-1 touch-target"
          >
            <span style={{ fontSize: 18 }}>🚪</span>
            <span className="text-[9px] font-bold tracking-wide text-white/40">Leave</span>
          </button>
        </div>
      </nav>
    );
  }

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-40 max-w-[430px] mx-auto"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
    >
      <div className="bg-surface/95 border-t border-white/8 backdrop-blur-xl flex">
        {ALL_NAV_ITEMS.map(({ path, label, icon }) => {
          const active = pathname === path || (path === '/session' && pathname.startsWith('/session'));
          const disabled = (path === '/session') && !currentSession;
          return (
            <button
              key={path}
              onClick={() => !disabled && navigate(path)}
              className={cn(
                'flex-1 flex flex-col items-center gap-1 py-2 px-1',
                'transition-all duration-150 touch-target',
                disabled && 'opacity-25 cursor-not-allowed'
              )}
            >
              <span
                className={cn('text-base transition-all', active && 'drop-shadow-[0_0_8px_rgba(196,181,253,0.9)]')}
                style={{ fontSize: 18 }}
              >
                {icon}
              </span>
              <span className={cn('text-[9px] font-bold tracking-wide', active ? 'text-brand-purple-light' : 'text-white/25')}>
                {label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};
